// FIXME: Esto debería venir del servidor
export const salas = [
    { nombre: '1', capacidad: 12, id: '1-3' },
    { nombre: '2', capacidad: 12, id: '1-6' },
    { nombre: '4', capacidad: 12, id: '2-1' },
    { nombre: '5', capacidad: 12, id: '2-2' },
    { nombre: '6', capacidad: 12, id: '2-3' },
    { nombre: '8', capacidad: 12, id: '3-1' },
    { nombre: '9', capacidad: 12, id: '3-2' },
    { nombre: '10', capacidad: 15, id: '3-4' },
    { nombre: 'A', capacidad: 25, id: 'O-1' },
    { nombre: 'B', capacidad: 50, id: 'O-2' },
] as const;

export type NombreDeSala = typeof salas[number]['nombre'];



// WEBPACK FOOTER //
// ./src/modulos/Horarios/salas.ts